import axios from "axios";
import { showAlert, handleRequestError } from "../../utils/alert";

export default () => ({
  email: "",
  password: "",
  isLoading: false,

  // Alpine lifecycle hook: Executa automaticamente ao iniciar o componente
  init() {
    this.checkExistingSession();
  },

  checkExistingSession() {
    const token = localStorage.getItem("admin_jwt_token");
    if (token) {
      // Se já houver token de admin, pula o login e vai direto para a dashboard Root.
      window.location.href = "/admin/dashboard";
    }
  },

  async submitLogin() {
    this.isLoading = true;

    // Validação Client-side (Evita chamadas desnecessárias à API)
    if (!this.email) {
      showAlert("E-mail é obrigatório", "warning");
      this.$refs.email.focus();
      this.isLoading = false;
      return;
    }

    if (!this.password) {
      showAlert("Senha é obrigatória", "warning");
      this.$refs.password.focus();
      this.isLoading = false;
      return;
    }

    // Capture the Turnstile token directly from the hidden input injected by Cloudflare
    const turnstileResponseInput = document.querySelector(
      '[name="cf-turnstile-response"]',
    );
    const turnstileToken = turnstileResponseInput
      ? turnstileResponseInput.value
      : null;

    if (!turnstileToken) {
      showAlert("Por favor, resolva o desafio de segurança.", "warning");
      this.isLoading = false;
      return;
    }

    try {
      // 1. Requisição para a API de autenticação do Admin Root
      const response = await axios.post("/api/admin/auth/login", {
        email: this.email,
        password: this.password,
        "cf-turnstile-response": turnstileToken,
      });

      const token = response.data.access_token;

      localStorage.setItem("admin_jwt_token", token);

      window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      await showAlert("Login realizado com sucesso!", "success");

      window.location.href = "/admin/dashboard";
    } catch (error) {
      // Agora o bloco catch vai capturar corretamente o JSON de erro 422 ou 403
      handleRequestError(error, "E-mail ou senha inválidos.");

      // Limpa e reseta o captcha para nova tentativa em caso de falha
      if (window.turnstile) {
        window.turnstile.reset();
      }
    } finally {
      this.isLoading = false;
    }
  },
});
